

























































































































































































































































































































































































import { Vue } from "vue-property-decorator";
import AppFiltresContent from "./components/contents.vue";
import { FiltreScolarite } from "@/models/_FiltresScolarite";
import { FiltrePointage } from "@/models/_FiltresPointage";
export default Vue.extend({
  components: { AppFiltresContent },
  data() {
    return {
      typeFiltre: "",
      isPrenomFirst: false,
      filtreActive: [] as Array<String>,
      filtresAutoriActive: -2,
      isResetAll: false,
      filtreIndividuJour: this.isIndividuDuJours,
    };
  },
  methods: {
    pointageFilter() {
      this.typeFiltre = "pointage";
    },
    filtreTemps() {
      this.typeFiltre = "temps";
    },
    closePanel() {
      this.typeFiltre = "";
    },
    filtres(params: any) {
      if (!this.filtreActive.includes(params.filtre))
        this.filtreActive.push(params.filtre);
      this.$emit("filtres", params);
      this.typeFiltre = "";
    },
    filtresnom() {
      this.isPrenomFirst = !this.isPrenomFirst;
      let params = {
        filtre: "prenom",
        value: this.isPrenomFirst,
      };
      this.$emit("filtres", params);
    },
    resetFiltre(filtre: string) {
      if (this.filtreActive.includes(filtre)) {
        let index = this.filtreActive.indexOf(filtre);
        this.filtreActive.splice(index, 1);
        this.$emit("close-filtre", filtre);
      }
    },
    resetAll() {
      if (this.typeFiltre !== "" || this.filtreActive.length !== 0) {
        this.typeFiltre = "";
        this.isPrenomFirst = false;
        this.filtreActive = [] as Array<String>;
        this.filtresAutoriActive = -2;
        this.isResetAll = true;
        this.$emit("close-filtre", "all");
      }
    },
    filtreAutori(filtre: number) {
      this.filtresAutoriActive = filtre;
      this.$emit("filtre-autori", filtre);
    },
  },
  props: {
    filtreScolarite: {
      type: FiltreScolarite,
      default: () => new FiltreScolarite(),
    },
    filtrePointage: {
      type: FiltrePointage,
      default: () => new FiltrePointage(),
    },
    hasSubHeader: {
      type: Boolean,
      default: false,
    },
    listVille: {
      type: Array,
      default: () => [],
    },
    currentActivite: {
      type: Object,
      default: () => {},
    },
    isIndividuDuJours: {
      type: Boolean,
      default: true,
    },
    dateTime: {
      type: String,
      default: "",
    },
  },
  watch: {
    filtreIndividuJour(newVal, oldVal) {
      this.$emit("individus-jour", newVal);
    },
    dateTime(newVal, oldVal) {
      this.resetAll();
    },
  },
});
